import { currentUser, currentUserRole, setCurrentUser, setCurrentUserRole } from "../state";
import { apiCall } from "../api";
import {
  loadAdminOverrides,
  loadDefaultStrategies,
  loadUserStrategies,
} from "./strategies";
import { loadReferenceFiles } from "./reference";

export function showAppUI(): void {
  (document.querySelector(".header") as HTMLElement).style.display = "";
  (document.querySelector(".container") as HTMLElement).style.display = "";
  (document.querySelector("footer") as HTMLElement).style.display = "";
  (document.getElementById("login-modal") as HTMLElement).style.display = "none";
}

export function showAuthUI(): void {
  (document.querySelector(".header") as HTMLElement).style.display = "none";
  (document.querySelector(".container") as HTMLElement).style.display = "none";
  (document.querySelector("footer") as HTMLElement).style.display = "none";
  (document.getElementById("login-modal") as HTMLElement).style.display = "flex";
  (document.getElementById("login-username") as HTMLInputElement).value = "";
  (document.getElementById("login-password") as HTMLInputElement).value = "";
}

export async function login(username: string, password: string): Promise<void> {
  const res = await apiCall("/api/login", "POST", { username, password });
  if (res && res.success) {
    localStorage.setItem("token", res.token);
    setCurrentUser(res.username);
    document.getElementById("user-name")!.innerText = currentUser || "";
    document.getElementById("login-btn")!.style.display = "none";
    document.getElementById("profile-dropdown")!.style.display = "inline-block";
    document.getElementById("dropbtn-name")!.innerText = currentUser || "";
    showAppUI();
    const me = await apiCall("/api/me", "GET");
    if (me && me.role) {
      setCurrentUserRole(me.role);
    }
    document.getElementById("admin-cache-card")!.style.display = currentUserRole === "admin" ? "block" : "none";
    document.getElementById("nav-admin-btn")!.style.display = currentUserRole === "admin" ? "inline-block" : "none";
    await loadAdminOverrides();
    await loadUserStrategies();
    await loadReferenceFiles();
  } else {
    alert("Ошибка входа");
  }
}

export async function logout(): Promise<void> {
  await fetch("/api/logout", {
    method: "POST",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  localStorage.removeItem("token");
  setCurrentUser(null);
  setCurrentUserRole("user");
  document.getElementById("user-name")!.innerText = "";
  document.getElementById("profile-dropdown")!.style.display = "none";
  document.getElementById("login-btn")!.style.display = "inline-block";
  document.getElementById("admin-cache-card")!.style.display = "none";
  document.getElementById("nav-admin-btn")!.style.display = "none";
  await loadDefaultStrategies();
  await loadReferenceFiles();
}

export async function doLogin(): Promise<void> {
  const username = (document.getElementById("login-username") as HTMLInputElement).value.trim();
  const password = (document.getElementById("login-password") as HTMLInputElement).value;
  if (username && password) {
    await login(username, password);
  }
}

export function initAuth(): void {
  document.getElementById("login-submit")!.onclick = doLogin;
  document.getElementById("login-username")!.addEventListener("keydown", (e) => {
    if (e.key === "Enter") doLogin();
  });
  document.getElementById("login-password")!.addEventListener("keydown", (e) => {
    if (e.key === "Enter") doLogin();
  });
  document.getElementById("auth-guest-btn")!.onclick = async () => {
    setCurrentUser(null);
    setCurrentUserRole("user");
    document.getElementById("user-name")!.innerText = "";
    document.getElementById("profile-dropdown")!.style.display = "none";
    document.getElementById("login-btn")!.style.display = "inline-block";
    document.getElementById("admin-cache-card")!.style.display = "none";
    document.getElementById("nav-admin-btn")!.style.display = "none";
    showAppUI();
    await loadDefaultStrategies();
    await loadReferenceFiles();
  };
  document.getElementById("login-btn")!.onclick = () => showAuthUI();
  document.getElementById("switch-user-btn")!.onclick = async () => {
    await logout();
    showAuthUI();
  };
  document.getElementById("logout-btn")!.onclick = async () => {
    await logout();
    showAuthUI();
    if (document.getElementById("admin-page")!.classList.contains("active-page")) {
      document.querySelectorAll(".nav-btn").forEach((b) => b.classList.remove("active"));
      document.querySelector('[data-page="mass"]')!.classList.add("active");
      document.querySelectorAll(".page").forEach((p) => p.classList.remove("active-page"));
      document.getElementById("mass-page")!.classList.add("active-page");
    }
  };
}
